import React from "react";
import Layout from "./../components/Layout/Layout";
import { Box, Typography } from '@mui/material'
import "../styles/HomeStyles.css";
import "../styles/HomeStyles.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
const Shipping = () => {
  return (
    <Layout>
      <Box className="home" width="100%" sx={{ textAlign: "center", my: 5 }}>
        <Typography variant="h4">Shipping and Delivery </Typography>
        <Box sx={{ textAlign: "center", my: 5, mx: 5, "& h4": { fontWeight: "bold", mb: 2 } }}>
          <Typography>Last updated on Dec 26, 2023.</Typography>
          {/* <Typography variant="h6" sx={{fontWeight:"bold", mt:3}}>Order Cancellations:</Typography>
          <Typography>UDVABAN TECHNOLOGIES PRIVATE LIMITED believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:</Typography> */}
          <Box
            alignItems="center"
            sx={{
              display: "flex",
              textAlign: "center",
              m: 3,
              mx: 25,
              "@media (max-width:1100px)": {
                mx: 0,
              },
              justifyContent: 'center'
            }}
          >
            <TableContainer component={Paper} elevation={5}>
              <Table sx={{ minWidth: 300 }} aria-label="simple table">
                <TableBody>
                  <TableRow
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center">
                      For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only. Orders are shipped within 1-7 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms. UDVABAN TECHNOLOGIES PRIVATE LIMITED is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 1-7 days rom the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on 9124080444 or ezibees8@gmail.com
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default Shipping;